var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faCalendarAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColorConfigs } from "@yodlee/common-components/dist/configurations";
import { NotificationUtils } from "@yodlee/common-components/dist/utilities";
import { Button, DatePicker, Icon, Input, Row, Typography } from "antd";
import Form from "antd/lib/form";
import FormItem from "antd/lib/form/FormItem";
import moment from "moment";
import React from "react";
import { FormFieldConfigs, LabelConfigs } from "../../../configurations";
import { DataUtils } from "../../../utilities";
var InsightUsersForm = /** @class */ (function (_super) {
    __extends(InsightUsersForm, _super);
    function InsightUsersForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            submitDisabled: false,
        };
        _this.componentDidMount = function () {
        };
        _this.componentDidUpdate = function () {
        };
        _this.onSubmit = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var _a = _this.props, form = _a.form, authentication = _a.authentication, roleId = _a.roleId, onCreate = _a.onCreate;
            _this.setState({ submitDisabled: true });
            form.validateFields(function (err, values) {
                if (!err) {
                    DataUtils.insightsUsers(authentication)
                        .create({
                        role: {
                            id: roleId
                        },
                        users: values.users.split(","),
                        validUntil: moment(values.validUntil).valueOf()
                    }).then(function () {
                        NotificationUtils.success(React.createElement(React.Fragment, null, "Success"), React.createElement(React.Fragment, null, "Users created successfully."));
                        onCreate();
                    }).finally(function () {
                        _this.setState({ submitDisabled: false });
                    });
                }
                else {
                    _this.setState({ submitDisabled: false });
                }
            });
        };
        _this.render = function () {
            var _a = _this.props, onCancel = _a.onCancel, roleName = _a.roleName;
            var _b = _this.props.form, getFieldDecorator = _b.getFieldDecorator, getFieldValue = _b.getFieldValue;
            var submitDisabled = _this.state.submitDisabled;
            return (React.createElement("div", { className: "padding-xl" },
                React.createElement(Typography.Title, { level: 3, style: { color: ColorConfigs.black, fontSize: "28px" } }, "Create Demo Users"),
                React.createElement(Typography.Paragraph, null,
                    " You are creating demo users for role: ",
                    roleName),
                React.createElement(Form, { className: "bold-label", onSubmit: _this.onSubmit, autoComplete: "off" },
                    React.createElement(Row, { gutter: { xs: 8, sm: 16, md: 24, lg: 32 }, className: "font-size-md padding-xs" },
                        React.createElement(FormItem, { label: React.createElement(React.Fragment, null, LabelConfigs.USERNAMES), required: true, colon: false }, getFieldDecorator(FormFieldConfigs.USERNAMES.key, {
                            rules: FormFieldConfigs.USERNAMES.rules(true)
                        })(React.createElement(Input.TextArea, { autoSize: { minRows: 3, maxRows: 15 }, placeholder: FormFieldConfigs.USERNAMES.placeholder }))),
                        React.createElement("span", { className: "font-size-sm", style: { marginTop: "-24px", float: "right" } },
                            (getFieldValue("users") || "").length,
                            "/500"),
                        React.createElement(FormItem, { label: React.createElement(React.Fragment, null, LabelConfigs.VALID_UNTIL), required: true, colon: false, className: "no-margin" }, getFieldDecorator(FormFieldConfigs.VALID_UNTIL.key, {
                            rules: FormFieldConfigs.VALID_UNTIL.rules(true)
                        })(React.createElement(DatePicker, { className: "small-date-picker", disabledDate: function (current) { return current ? current < moment() ? true : false : false; }, placeholder: FormFieldConfigs.VALID_UNTIL.placeholder, style: { width: "40%" }, format: "MM/DD/YYYY hh:mm A", suffixIcon: React.createElement(Icon, { className: "color-gray-5", component: function () { return React.createElement(FontAwesomeIcon, { icon: faCalendarAlt }); } }), allowClear: true, showTime: true, showToday: false })))),
                    React.createElement(Row, null,
                        React.createElement("div", { style: { marginTop: "16px", textAlign: "right" } },
                            React.createElement(Button, { type: "default", className: "margin-right-md", onClick: onCancel }, "Cancel"),
                            React.createElement(Button, { type: "primary", htmlType: "submit", onClick: _this.onSubmit, disabled: submitDisabled }, "Save changes"))))));
        };
        return _this;
    }
    return InsightUsersForm;
}(React.Component));
export default Form.create({ name: 'insights-users-form' })(InsightUsersForm);
//# sourceMappingURL=index.js.map